module.exports = __webpack_public_path__ + "img/ximiannai004.6594dbcc.jpg";